
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../pages/Dashboard/Sidebar";
import Navbar from "../../components/Navbar/Navbar";
import MainContent from "../../pages/Dashboard/MainContent";
import useIsMobile from "../../hooks/useIsMobile";
import useAuth from "../../hooks/useAuth";

const Dashboard = () => {
  const version = process.env.REACT_APP_API_VERSION;
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { auth } = useAuth();

  const isMobile = useIsMobile();
  const location = useLocation();
  
  const toggleSidebar = () => setIsSidebarOpen((s) => !s);

    //Cerrar sidebar automáticamente al cambiar de ruta (solo mobile)
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <div className="flex h-screen min-h-0 flex-col bg-gray-100">

      {/* NAVBAR siempre arriba */}
      <Navbar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        user={auth.user}
      />

      {/* Contenedor principal */}
      <div className="flex flex-1 min-h-0 overflow-hidden lg:flex-row flex-col">

        {/* SIDEBAR */}
        <div
          className={`
            ${isSidebarOpen ? "block" : "hidden"}
            md:${isSidebarOpen ? "block" : "hidden"}
            w-full
            lg:w-64
            flex-shrink-0
          `}
        >
          <Sidebar isSidebarOpen={isSidebarOpen} version={version} />
        </div>

        {/* MAIN CONTENT */}
        <div className="flex-1 min-w-0 overflow-auto">
          <MainContent />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
